import { W as WuiLayout$1, d as defineCustomElement$1 } from './p-DKss2Fy6.js';

const WuiLayout = WuiLayout$1;
const defineCustomElement = defineCustomElement$1;

export { WuiLayout, defineCustomElement };
